import {
  DIRECT_TO_HOME,
  FUSION_CLOSER,
  FUSION_SETTER,
  getSplatUserType,
  type UserProfile,
} from "@sunrun/sales-experience-shared";

const isStreetOrFusionRep = (userProfile: UserProfile | undefined): boolean => {
  if (!userProfile) {
    return false;
  }

  const userType = getSplatUserType(userProfile);
  return (
    userType === DIRECT_TO_HOME ||
    userType === FUSION_CLOSER ||
    userType === FUSION_SETTER
  );
};

type HideSolarRateColumnOptions = {
  hasHybridAuth?: boolean;
  userRole?: "design" | "sales";
};

const shouldHideSolarRateColumn = (
  state: string | undefined,
  financialProduct: string | undefined,
  changeOrder: boolean,
  userProfile: UserProfile | undefined,
  options?: HideSolarRateColumnOptions
): boolean => {
  if (changeOrder || !financialProduct?.toLowerCase().includes("monthly")) {
    return false;
  }

  if (state === "PR") {
    return true;
  }

  if (state === "IL") {
    if (!options?.hasHybridAuth && options?.userRole === "sales") {
      return true;
    }

    return Boolean(userProfile?.isPartner || isStreetOrFusionRep(userProfile));
  }

  return false;
};

export {
  isStreetOrFusionRep,
  shouldHideSolarRateColumn,
  type HideSolarRateColumnOptions,
};
